import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import Modal from "react-modal";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddContest from "../partials/AddContest";
import LiveContest from "../partials/contest/LiveContest";
import UpcomingContest from "../partials/contest/UpcomingContest";
import PastContest from "../partials/contest/PastContest";
import MyContest from "../partials/contest/MyContest";
import CommunityContest from "../partials/contest/CommunityContest";
import LeaderboardGloble from "../partials/exchange/LeaderboardGloble";
import ContestUpdateModal from "../partials/ContestUpdateModal";
import socketIOClient from "socket.io-client";
import { toast, Toaster } from "react-hot-toast";
import * as myConstList from "../../BaseUrl";
import { questionAnswer } from "../../actions/orderAction";
import ReactGA from "react-ga";
import moment from "moment";
import { ContactSupportOutlined } from "@material-ui/icons";

const jwtToken = localStorage.getItem("jwtToken");
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questionRecords: [],
      visibleIndex: 0,
      correctQuestion: [],
      submitCorrectAnswer: [],
      ordersRecord: {},
      leaderboardPaticipants: [],
      entryFeePoints: 0,
      expriryDateTime: "",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      modalOf: false,
    };

    // this.getData = this.getData.bind(this);
    const url = window.location.href;
    const lastSegment = url.split("/").pop();
  }

  getPortfolioData = () => {
    // timer set
    var expriry = this.state.expriryDateTime;
    var dateformat = this.state.serverTime;
    var currentDate = dateformat;
    // var expriry1 = Date.parse(expriry);
    var expriry1 = moment(String(expriry));
    // expriry = expriry.toString();
    var expriry2 = expriry1;

    var expriry3 = expriry2 / 1000;
    // currentDate = Date.parse(currentDate);
    var currentDate1 = moment(String(currentDate));
    // currentDate = currentDate.toString();
    // currentDate = this.parseDate(currentDate);
    // console.log('currentDate', currentDate1)
    var currentDate2 = currentDate1 / 1000;
    const countdown = moment(expriry3 - currentDate2);
    var duration = moment.duration(countdown * 1000, "milliseconds");
    var interval = 1000;
    duration = moment.duration(duration - interval, "milliseconds");

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const symbol1 = this.props.symbol;
    // console.log(seconds, "secondd", days, hours, minutes, seconds);
    this.setState({ days, hours, minutes, seconds });
    if (seconds <= 0) {
      clearInterval(interval);
    }
    if (
      days <= 0 &&
      minutes <= 0 &&
      hours <= 0 &&
      seconds <= 0 &&
      !this.state.modalOf
    ) {
      // console.log("kkkkk");
      this.state.modalOf = true;
      // timeout process API
      // console.log("this.state.contestId=", this.state.contestId);
      var collectThis = this;
      const socket = socketIOClient(baseUrl, {
        query: "jwtToken=" + jwtToken + "&contestId=" + this.state.contestId,
      });

      this.setState({ socketCollect: socket });
      socket.on("connect", () => {
        // console.log("dashboardSocket==");
        collectThis.setState({ currentSocketId: socket.id });
        socket.emit("timeOutProcess");
      });
      //
      // this.openTimerModal();
      setTimeout(function () {
        // console.log("hiiikkk");
        // window.location.href = window.location.pathname;
        window.location.href = "/dashboard";
      }, 3000);
    }
    // timer end
  };

  getdata() {
    let contestId = this.props.match.params.id;

    // const socket = socketIOClient(baseUrl, {
    //   query:
    //     "jwtToken=" +
    //     jwtToken +
    //     "&contestId=" +
    //     this.state.contestId +
    //     "&symbol=" +
    //     this.props.match.params.symbol +
    //     "&exchangetype=" +
    //     this.props.match.params.exchangetype +
    //     "&&contestType=price",
    // });

    const socket = socketIOClient(baseUrl, {
      query:
        "jwtToken=" +
        jwtToken +
        "&contestId=" +
        contestId +
        "&&contestType=forcasting",
    });
    this.setState({ socketCollect: socket });
    let collectThis = this;
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("callExchangeData");
      socket.emit("participateDataCall");
      // console.log("CallExchnageData===");
    });

    socket.on("forcastContestByIdData", function (apiRespData) {
      // console.log("hiIIIIIIIIIIIII", apiRespData);
      // console.log("apiRespData===",apiRespData.data.item.endDate);
      if (apiRespData?.data?.length > 0) {
        // const tempEndDateTime = apiRespData.data.item.endDate + " " + apiRespData.data.item.endTime;
        const tempEndDateTime = apiRespData.data[0].endDate;

        // console.log("apiRespData.data.pair===",apiRespData.data.pair);
        collectThis.setState({
          // records: apiRespData.data.item,
          // virtualFundassign: apiRespData.data.item.virtualFund,
          expriryDateTime: tempEndDateTime,
          // tempArrPair: apiRespData.data.item.pair_id,
          // pair: apiRespData.data.pair,
        });
      }
    });

    socket.on("serverTime", function (apiRespData) {
      // console.log(apiRespData, "servertime");
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({ serverTime: apiRespData });
      }
    });

    socket.on("participateData", function (apiRespData) {
      console.log("apiRespData.data=========", apiRespData.data);
      // if (socket.id == collectThis.state.currentSocketId) {
      collectThis.setState({
        leaderboardPaticipants: apiRespData.data,
      });
      // }
    });
    axios
      .post(baseUrl + "api/forcasting-order", { contestId: contestId })
      .then((res) => {
        // console.log("profile-data=======",res.data.message);
        if (res.data.message) {
          this.setState({ ordersRecord: [] });
        } else {
          this.setState({ ordersRecord: res.data });
        }
      })
      .catch();
  }
  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
    let contestId = this.props.match.params.id;

    if (contestId) {
      this.intervalExchnge = setInterval(() => {
        this.getPortfolioData();
      }, 1000);
    } else {
      clearInterval(this.intervalExchnge);
    }

    axios
      .post(baseUrl + "api/question-data-contestWise", { contestId: contestId })
      .then((res) => {
        // console.log("profile-data=======", res.data.data);
        this.setState({ questionRecords: res.data.data });
      })
      .catch();
    axios
      .post(baseUrl + "api/contestByID-data", { id: contestId }, configToken)
      .then((res) => {
        if (res.data.data.item) {
          this.setState({ entryFeePoints: res.data.data.item.entryFeePoints });
        }
      });
    this.getdata();
    // console.log("profile-data==");
    // .post(baseUrl + "api/profile-data", {},configToken)
  }

  componentWillUnmount() {
    //  clearInterval(this.intervalcontest);
    var getSocket = this.state.socketCollect;
    getSocket.emit("disconnectContestApi");
  }
  editRecord(record) {
    this.setState({ currentRecord: record });
  }

  tabClick(tabType) {
    window.webengage.track("Contest_category viewed", {
      "Category Name": tabType,
    });
  }
  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }
  previousButtonClick(i) {
    let index = i - 1;
    this.setState({ visibleIndex: index });
  }
  nextButtonClick(i) {
    let index = i + 1;
    this.setState({ visibleIndex: index });
  }
  onChange = (e) => {
    e.preventDefault();
    let targetId = e.target.id;
    this.setState({ targetId: e.target.value });
  };
  correctAnswer(optionNumber, questionId) {
    var tempArr = [];
    var tempObj = {};
    this.state.correctQuestion.push({
      questionId: questionId,
      optionNumber: optionNumber,
    });
    // console.log("this.state.correctQuestion==",this.state.correctQuestion);
    this.state.correctQuestion.map((val, i) => {
      tempObj[val.questionId] = val.optionNumber;
      tempArr.push(tempObj);
      // console.log("questionId====",questionId,val.optionNumber)
    });
    const uniqueIds = [];
    let uniqueArray = tempArr.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.id);
      if (!isDuplicate) {
        uniqueIds.push(element.id);
        return true;
      }
      return false;
    });
    let convrtInArr = Object.entries(uniqueArray[0]);
    let uniqueArray1 = [];
    convrtInArr.map((val, i) => {
      uniqueArray1.push({ questionId: val[0], optionNumber: val[1] });
    });
    // console.log("uniqueArrayuniqueArray=", uniqueArray1);
    this.state.submitCorrectAnswer = uniqueArray1;
    // this.state.correctQuestion[questionId] = optionNumber;
    // console.log("correctQuestioncorrectQuestion========",this.state.submitCorrectAnswer);
  }
  showParticipantsHtml = () => {
    var html = [];
    console.log(
      "this.state.leaderboard.length=",
      this.state.leaderboardPaticipants
    );
    if (this.state.leaderboardPaticipants.length > 0) {
      this.state.leaderboardPaticipants.map(function (value, i) {
        html.push(
          <tr>
            <td className="col-3 ">{i + 1}</td>
            <td className="col-3 ">{value.name}</td>
            <td className="col-3 ">
              {value.mobile === ""
                ? value.email
                : value.mobile.replace(/\d(?=\d{4})/g, "*")}
            </td>
            {/* <td className="col-3 "></td> */}
          </tr>
        );
      });
    }
    return html;
  };

  onSubmitUpdate() {
    // e.preventDefault();
    const newAnswerUser = {
      correctAnswer: this.state.submitCorrectAnswer,
      contestId: this.props.match.params.id,
    };
    // console.log("newAnswerUser==",newAnswerUser);
    this.props.questionAnswer(newAnswerUser);
    this.getdata();
  }
  questionHtml() {
    if (this.state.questionRecords.length > 0) {
      return this.state.questionRecords.map((val, i) => (
        // style={{display:this.state.visibleIndex==i?"block":"none"}}
        <div
          className="white_box "
          style={{ display: this.state.visibleIndex == i ? "block" : "none" }}
        >
          <div className="question ">
            <div className="h5 mb-3">
              <b>
                Q{i + 1}. {val.question}
              </b>
            </div>
            <div className="pt-3 row" id="options">
              <div className="col-md-4 col-6">
                <label className="options">
                  {val.option1}
                  {/* {this.state.ordersRecord.length} */}
                  <input
                    type="radio"
                    name={"radio" + i}
                    id="option1"
                    onClick={() => this.correctAnswer(1, val.id)}
                    disabled={this.state.ordersRecord.length > 0 ? true : ""}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-md-6 col-6">
                <label className="options">
                  {val.option2}
                  <input
                    type="radio"
                    name={"radio" + i}
                    id="option2"
                    onClick={() => this.correctAnswer(2, val.id)}
                    disabled={this.state.ordersRecord.length > 0 ? true : ""}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-md-4 col-6">
                <label className="options">
                  {val.option3}
                  <input
                    type="radio"
                    name={"radio" + i}
                    id="option3"
                    onClick={() => this.correctAnswer(3, val.id)}
                    disabled={this.state.ordersRecord.length > 0 ? true : ""}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-md-6 col-6">
                <label className="options">
                  {val.option4}
                  <input
                    type="radio"
                    name={"radio" + i}
                    id="option4"
                    onClick={() => this.correctAnswer(4, val.id)}
                    disabled={this.state.ordersRecord.length > 0 ? true : ""}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center pt-4">
            {i !== 0 && (
              <div id="prev">
                <button
                  className="btn previous_btn"
                  onClick={() => this.previousButtonClick(i)}
                >
                  Previous
                </button>
              </div>
            )}
            {this.state.questionRecords.length !== i + 1 && (
              <div className="ml-auto mr-sm-5">
                <button
                  className="btn btn_man"
                  onClick={() => this.nextButtonClick(i)}
                >
                  Next
                </button>
              </div>
            )}
            {this.state.ordersRecord.length === 0 &&
              this.state.questionRecords.length == i + 1 && (
                <div className="ml-auto mr-sm-5">
                  <button
                    className="btn btn_man"
                    onClick={() => this.onSubmitUpdate(i)}
                  >
                    Submit
                  </button>
                </div>
              )}
          </div>
        </div>
      ));
    } else {
      return (
        <div className="container mt-4">
          <div className="crypt-market-status2 data_not_found pt-5 pb-5 text-center">
            <p className="mt-5 mb-5 text-center">No questions found</p>
          </div>
        </div>
      );
    }
  }
  render() {
    return (
      <>
        <Navbar
          urlPath={true}
          symbol={false}
          thirdPhaseConfig={this.state.thirdPhaseConfig}
        />
        <Sidebar />
        <div className="in_page">
          <div className="container">
            <div className="row mb-3">
              <h5 className="mb-0 col-auto">MCQ Quiz</h5>
              <div className="col-auto ml-auto">
                <div className="pool_amount_box ml-auto">
                  <div className="">Pool Amount:</div>
                  <div className="ml-4">
                    {this.state.leaderboardPaticipants.length *
                      this.state.entryFeePoints}
                    {/* {this.state.records.entryFeePoints*this.state.leaderboard.length} */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                {/* <form noValidate id="update-user"> */}
                {this.questionHtml()}
                {/* </form> */}
              </div>
              <div className="col-md-4">
                {/* <h5 className="mb-3">Participates</h5> */}
                <div className="white_box">
                  <ul className="nav nav-tabs nav-tabs5" id="crypt-tab">
                    <li role="presentation">
                      <a
                        className="active show"
                        href="#MarketTradesParticipants"
                        data-toggle="tab"
                      >
                        Participants
                      </a>
                    </li>
                  </ul>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="MarketTradesParticipants"
                  >
                    <div className="table-overflow mb-2">
                      <div className="table-responsive">
                        <table className="table border_none mb-0">
                          <thead>
                            <tr>
                              {/* <th className="col-4">Price(USDT)</th>
                                    <th className="col-4">Amount({props.curruncyName})</th>

								<th className="col-4 tr">Time</th>*/}
                              <th className="col-3">Sr No.</th>
                              <th className="col-3">User</th>
                              <th className="col-3">Mobile</th>
                            </tr>
                          </thead>
                          <tbody className="crypt-table-hover">
                            {this.showParticipantsHtml()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
        {this.state.modalOf && (
          <Modal show={true}>
            <div>
              <div className="auto_box">
                <div className="white_box tc">
                  <img src="/img/time-out.gif" />
                  <br />
                  <br />
                  <h4>Time Out</h4>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </>
    );
  }
}

Question.propTypes = {
  auth: PropTypes.object.isRequired,
  questionAnswer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  contestdata: state.contestdata,
  records: state.records,
});

export default connect(mapStateToProps, { questionAnswer })(Question);
